/* Self-contained campaign navigation. It must not depend on the selected Banner. */
(function () {
  'use strict';
  if (window.sgBfNav) { window.sgBfNav.scan(); return; }
  var controllers = new Map();
  var headerSelector = 'sticky-header,.shopify-section-header-sticky,.header-wrapper,[data-sticky-header],.section-header,.announcement-bar';
  function fixedAncestor(node) {
    for (var p = node; p && p !== document.body; p = p.parentElement) {
      var position = getComputedStyle(p).position;
      if (position === 'fixed' || position === 'sticky') return true;
    }
    return false;
  }
  function headerBottom() {
    var bottom = 0;
    Array.from(document.querySelectorAll(headerSelector)).filter(fixedAncestor).map(function (node) {
      return node.getBoundingClientRect();
    }).filter(function (r) { return r.width > 0 && r.height > 0 && r.height < window.innerHeight * .6 && r.bottom > 0; }).sort(function (a,b) { return a.top - b.top; }).forEach(function (r) {
      if (r.top <= bottom + 1) bottom = Math.max(bottom, r.bottom);
    });
    return Math.max(0, bottom);
  }
  function setup(shell) {
    if (controllers.has(shell)) return;
    var nav = shell.querySelector('[data-sg-anchor-nav]'); if (!nav) return;
    var links = Array.from(nav.querySelectorAll('[data-sg-anchor-link]'));
    var removers = [], frame = 0, dead = false, pinned = false, resizeObserver, headerObserver;
    var originalHeight = shell.style.height, originalNavStyle = nav.getAttribute('style'), slot = document.createComment('SG campaign navigation slot');
    nav.before(slot);
    function listen(target, type, fn, options) { target.addEventListener(type,fn,options); removers.push(function () { target.removeEventListener(type,fn,options); }); }
    function restore() {
      if (slot.parentNode) slot.after(nav); else nav.remove();
      if (originalNavStyle === null) nav.removeAttribute('style'); else nav.setAttribute('style',originalNavStyle);
      nav.classList.remove('is-pinned'); shell.classList.remove('is-pinned'); shell.style.height = originalHeight;
      pinned = false;
    }
    function resolve(link) {
      var id = link.getAttribute('data-sg-anchor-link');
      return window.sgBfAnchors ? window.sgBfAnchors.resolve(id) : document.getElementById(id);
    }
    function activeLink(top) {
      var current, first;
      links.forEach(function (link) {
        var target = resolve(link); if (!target) return;
        var rect = target.getBoundingClientRect();
        if (!first) first = link;
        if (rect.top <= top + nav.offsetHeight + 32 && rect.bottom > top) current = link;
      });
      if (!current) {
        var before = links.filter(function (link) { var t=resolve(link); return t && t.getBoundingClientRect().top <= top + nav.offsetHeight + 32; });
        current = before.length ? before[before.length - 1] : first;
      }
      // A short final section may hit the document end before its heading reaches the sticky line.
      var scroller = document.scrollingElement;
      if (scroller && scroller.scrollTop + window.innerHeight >= scroller.scrollHeight - 2) {
        var visibleLast = links.filter(function (link) { var t=resolve(link); return t && t.getBoundingClientRect().top < window.innerHeight; });
        if (visibleLast.length) current = visibleLast[visibleLast.length - 1];
      }
      links.forEach(function (link) { var active = link === current; link.classList.toggle('is-active',active); if (active) link.setAttribute('aria-current','location'); else link.removeAttribute('aria-current'); });
    }
    function update() {
      frame = 0; if (dead || !shell.isConnected) return;
      var top = headerBottom(), shouldPin = shell.dataset.sticky === 'true' && shell.getBoundingClientRect().top <= top;
      if (shouldPin) {
        if (!pinned) {
          shell.style.height = nav.getBoundingClientRect().height + 'px';
          document.body.appendChild(nav); pinned = true;
          shell.classList.add('is-pinned'); nav.classList.add('is-pinned');
          // Body portal avoids transformed/overflow section wrappers becoming the fixed container.
          nav.style.setProperty('position','fixed','important'); nav.style.setProperty('left','0'); nav.style.setProperty('right','0'); nav.style.setProperty('width','auto'); nav.style.setProperty('z-index','100');
        }
        nav.style.setProperty('--sg-bf-anchor-top',top + 'px'); nav.style.setProperty('top',top + 'px');
        shell.style.height = nav.getBoundingClientRect().height + 'px';
      } else if (pinned) restore();
      activeLink(top);
    }
    function schedule() { if (!frame && !dead) frame = requestAnimationFrame(update); }
    links.forEach(function (link) {
      listen(link,'click',function (event) {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        var target = resolve(link); if (!target) return;
        event.preventDefault();
        var offset = headerBottom() + (shell.dataset.sticky === 'true' ? nav.getBoundingClientRect().height : 0) + 16;
        target.style.scrollMarginTop = offset + 'px';
        target.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
        history.replaceState(null,'','#' + encodeURIComponent(target.id));
        // Scroll only this horizontal list; do not scroll the page while revealing the active item.
        var inner = nav.querySelector('.sg-bf-anchor-nav-inner'), lr = link.getBoundingClientRect(), ir = inner && inner.getBoundingClientRect();
        if (inner && (lr.left < ir.left || lr.right > ir.right)) inner.scrollTo({left:inner.scrollLeft + lr.left - ir.left - (ir.width - lr.width)/2,behavior:'smooth'});
        schedule();
      });
    });
    listen(document,'scroll',schedule,{capture:true,passive:true}); listen(window,'resize',schedule,{passive:true});
    listen(document,'load',schedule,{capture:true,passive:true}); listen(document,'sg:anchors:updated',schedule);
    listen(document,'transitionend',schedule,{capture:true,passive:true});
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
    if ('ResizeObserver' in window) { resizeObserver = new ResizeObserver(schedule); resizeObserver.observe(shell); resizeObserver.observe(nav); if (document.body) resizeObserver.observe(document.body); document.querySelectorAll(headerSelector).forEach(function (n) { resizeObserver.observe(n); }); }
    if ('MutationObserver' in window) { headerObserver = new MutationObserver(schedule); document.querySelectorAll(headerSelector).forEach(function (n) { headerObserver.observe(n,{attributes:true,attributeFilter:['class','style','hidden']}); }); }
    var controller = { refresh:schedule, destroy:function () { dead=true; cancelAnimationFrame(frame); removers.forEach(function (remove) { remove(); }); if(resizeObserver)resizeObserver.disconnect(); if(headerObserver)headerObserver.disconnect(); restore(); slot.remove(); controllers.delete(shell); } };
    controllers.set(shell,controller); schedule();
  }
  function scan(scope) { var base=scope||document; if(base.matches&&base.matches('[data-sg-nav-controller="standalone"]'))setup(base); base.querySelectorAll('[data-sg-nav-controller="standalone"]').forEach(setup); }
  window.sgBfNav={scan:scan,controllers:controllers};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){scan();});else scan();
  document.addEventListener('shopify:section:load',function(e){scan(e.target);});
  document.addEventListener('shopify:section:unload',function(e){controllers.forEach(function(c,shell){if(shell===e.target||e.target.contains(shell))c.destroy();});});
})();
